import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { BookAuthor } from "@modules/bookAuthors/types";
import { BookAuthorFormValues } from "@modules/bookAuthors/validations";

import { editBookAuthorService } from "./service";
import { UseEditBookAuthorMutationOptions } from "./types";

export function useEditBookAuthorMutation(
  options?: UseEditBookAuthorMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<BookAuthor, ApiError, { id: string; data: BookAuthorFormValues }>({
    mutationFn: ({ id, data }) => editBookAuthorService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("book_contributor_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
